import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const BaseUrlContext = React.createContext({});
export function BaseUrlProvider({ baseurl, children, }) {
    return _jsx(BaseUrlContext.Provider, { value: { baseurl }, children: children });
}
export function useBaseurl() {
    const data = useContext(BaseUrlContext);
    return data === null || data === void 0 ? void 0 : data.baseurl;
}
export function withBaseurl(url, baseurl) {
    if (baseurl)
        return baseurl + url;
    return url;
}
